import { Measurement } from './_types';

export const LIB_MEASURES_HARVEST_PHYSIOLOGY : Measurement[] = [
    {
        id: "frut_physiology_chill",
        unit: "%",
        label: "Chilling injury",
        tag: "CHI",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_physio_chill_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_physiology",
    },
    {
        // PREVIOUSLY Weight loss and shrivelling
        id: "frut_physiology_wei_l",
        unit: "%",
        label: "Shrivelling",
        tag: "WEL",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_physio_wel_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_physiology",
    },
    {
        // PREVIOUSLY Internal breakdown and Aril browning
        id: "frut_physiology_int_b",
        unit: "%",
        label: "Aril browning",
        tag: "INB",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_physio_inb_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_physiology",
    },
    {
        id: "frut_physiology_sun",
        unit: "%",
        label: "Sunburn carry-over",
        tag: "SUN",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_physio_sun_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_physiology",
    },
    {
        id: "frut_physiology_crack",
        unit: "%",
        label: "Postharvest cracking",
        tag: "PCR",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_physio_pcr_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_physiology",
    },
    {
        id: "frut_physiology_rind",
        unit: "%",
        label: "Rind scald",
        tag: "RIN",
        defaultChart: "chart_bar_buckets",
        defaultBucket: "bucket_frut_physio_rin_10",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "frut_physiology",
    },
];